import clsx from "clsx";

import { Icon } from "../Icon";
import Tooltip from "../Tooltip";

export default function SandboxBadge({ className }: { className?: string }) {
  return (
    <span className={clsx("mb-[3px]", className)}>
      <Tooltip
        text="Sandbox workspace"
        position="right"
        className="h-full w-full"
      >
        <span
          className="flex h-full w-full items-center justify-center rounded-full bg-amber-100 ring-2 ring-white"
          role="img"
          aria-label="Sandbox workspace"
        >
          <Icon name="flask" className="h-2.5 w-2.5 text-black" />
        </span>
      </Tooltip>
    </span>
  );
}
